module.exports = __webpack_public_path__ + "static/media/stade_centenaire.27a149f4.jpg";